<script>
import fieldMixin from '@maison/mixins/fieldMixin';
import { isEmpty } from 'lodash-es';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [fieldMixin],

  props: {
    parentId: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    radioClasses() {
      return {
        'sgphx-radio': this.isSgphx,
        'sgphx-radio--invalid': this.isSgphx && this.isInvalid,
        radio: !this.isSgphx,
        'radio--invalid': !this.isSgphx && this.isInvalid,
      };
    },
    inputClasses() {
      return {
        'sgphx-radio__input': this.isSgphx,
        radio__input: !this.isSgphx,
      };
    },
    labelClasses() {
      return {
        'sgphx-radio__label': this.isSgphx,
        radio__label: !this.isSgphx,
      };
    },
    ariaDescribedby() {
      return `${this.parentId}-label ${this.parentId}-error ${this.parentId}-help`;
    },
    inputValue() {
      return isEmpty(this.field.value) ? this.field.id : this.field.value;
    },
  },
};
</script>

<template>
  <div :class="radioClasses">
    <input
      :id="fieldUniqueId"
      v-model="value"
      :value="inputValue"
      :name="field.name"
      :aria-describedby="ariaDescribedby"
      type="radio"
      :class="inputClasses"
      :data-cy="attrs.dataCy"
    />
    <label :for="fieldUniqueId" :class="labelClasses" v-html="field.label" />
  </div>
</template>
